'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var magnitudes = ['thousand', 'million', 'billion', 'trillion', 'quadrillion'];

var addMagnitudes = function addMagnitudes(string, index) {
  return string && index ? string + ' ' + magnitudes[index - 1] : string;
};

exports.default = addMagnitudes;